import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiIconModule } from '../../components';

import { EuiSidebarToggleComponent } from './sidebar-toggle.component';

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
    ],
    exports: [
        EuiSidebarToggleComponent,
    ],
    declarations: [
        EuiSidebarToggleComponent,
    ],
})
export class EuiSidebarToggleModule {
}
